import { render, staticRenderFns } from "./ProductsGallery.vue?vue&type=template&id=41da9e0a"
import script from "./ProductsGallery.vue?vue&type=script&lang=js"
export * from "./ProductsGallery.vue?vue&type=script&lang=js"
import style0 from "./ProductsGallery.vue?vue&type=style&index=0&id=41da9e0a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports